import React from "react";

export function NoAthletesOverview({ clientWord, t }) {
  const clientWordLower = clientWord.toLowerCase();
  const clientWordSingular = clientWord.slice(0, -1);

  return (
    <div className="no-athlete-overview-section">
      <p>{t("coachingDashboard.noActiveRole", { role: clientWordLower })}</p>
      <span>
        {t("coachingDashboard.emptyStateDescription", {
          role: clientWordLower,
        })}
      </span>
      <a
        role="button"
        data-button-type="primary"
        href={`/coaching-portal/athletes/?modal[type]=invite-athlete`}
      >
        {t("coachingDashboard.inviteRole", { role: clientWordSingular })}
      </a>
    </div>
  );
}
